import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { useAnalytics } from './useAnalytics';

type Props = {
  eventName?: string;
  payload?: object;
  isEnabled?: boolean;
};

export const usePageLoadAnalyticsEvent = ({
  eventName,
  payload,
  isEnabled = true,
}: Props) => {
  const { sendEvent, isLoading } = useAnalytics();
  const [isSent, setIsSent] = useState<boolean>(false);

  useQuery({
    queryKey: [eventName, payload],
    queryFn: async () => {
      if (eventName) {
        await sendEvent(eventName, payload);
      }
      setIsSent(true);
      return null;
    },
    enabled: Boolean(eventName) && isEnabled && !isLoading && !isSent,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    retry: false,
  });
};
